import { createFileRoute } from '@tanstack/react-router'
import { ApiDocsPage } from '../components/pages'
import { staticRouteHead } from '../lib/seo'

export const Route = createFileRoute('/fr/api-docs')({
  head: () => staticRouteHead('apiDocs', 'fr'),
  component: ApiDocsPage,
})
